import * as types from './mutations-type';
export default {
  // 设置登录身份
  [types.SET_PORTORG](state, data) {
    state.portOrg = data;
    console.log('SET_PORTORGstate', state);
  },
  // 设置用户身份信息
  [types.SET_ADMINIDENTITY](state, data) {
    state.adminIdentity = data;
    localStorage.setItem('adminIdentity', JSON.stringify(data));
  },
  // 设置用户身份信息
  [types.SET_ADMINIDENTITYINDEX](state, data) {
    state.adminIdentityIndex = data;
    localStorage.setItem('adminIdentityIndex', data);
  },
  // 设置用户身份标识
  [types.SET_THEUSERIDENTITY](state, data) {
    state.theUserIdentity = data;
    localStorage.setItem('theUserIdentity', data);
  },
  // 设置路由列表
  [types.SET_ROUTELIST](state, data) {
    state.routeList = data;
    localStorage.setItem('routeList', JSON.stringify(data));
  },
  // 保存当前路由信息
  [types.SET_CURRENTROUTEINFO](state, routeInfo) {
    state.currentRouteInfo = routeInfo;
  },
  [types.SET_USERINFO](state, userInfo) {
    state.userInfo = userInfo;
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
  },
  // 设置左边栏菜单
  [types.SET_LEFTNAVLIST](state, navList) {
    state.leftNavList = navList;
    localStorage.setItem('leftNavList', JSON.stringify(navList));
  },
  [types.SET_UPLOADTOKEN](state, token) {
    state.fileUploadToken = token;
  },
  [types.SET_UPLOADURL](state, url) {
    state.fileUploadUrl = url;
  },
  [types.SET_STATERESET](state) {
    for (const p in state) {
      console.log(p, state[p]);
      if (state.hasOwnProperty(p)) {
        if (Array.isArray(state[p])) {
          state[p] = [];
        } else if (typeof state[p] === 'string') {
          state[p] = '';
        }
      }
    }
  },
  [types.SET_CACHEROUTE](state, cache) {
    state.cacheRoute = cache;
  },
  [types.PUSH_CACHEROUTE](state, cache) {
    state.cacheRoute.includes(cache)
      ? ''
      : (state.cacheRoute = [...state.cacheRoute, cache]);
  },
  [types.DELETE_CACHEROUTE](state, cache) {
    state.cacheRoute = state.cacheRoute.filter((item) => {
      return item != cache;
    });
  },

  [types.SET_TABSLIST](state, data) {
    state.tabsList = data;
  },
  [types.SET_SCHOOLLIST](state, data) {
    state.schoolList = data;
  },
  [types.SET_SCHOOLINDEX](state, data) {
    state.schoolIndex = data;
  },
  // 设置 运营端 查询 机构列表
  [types.SET_ORGBYOPE](state, data) {
    state.orgByOpe = data;
  },
  // 设置 运营端 查询 学校列表
  [types.SET_SCHBYOPE](state, data) {
    state.schByOpe = data;
  },
  // 设置 运营端 查询 学校列表
  [types.SET_SCHBYOPE](state, data) {
    state.schByOpe = data;
  },
  setCheckStuListStore(state, data) {
    state.checkStuListStore = data;
  },
  // 设置 自定义表头显示
  [types.SET_COLUMNS_MODULE](state, data) {
    // data

    for (const k in data) {
      state.columnsModule[k] = data[k];
      console.log(data[k]['isCheck'], k);
      if (data[k]['isCheck']) {
        localStorage.setItem(
          'columnsModule',
          JSON.stringify(state.columnsModule)
        );
      } else {
        const mol = localStorage.getItem('columnsModule')
          ? JSON.parse(localStorage.getItem('columnsModule'))
          : '';
        if (mol) {
          mol[k] = '';
          localStorage.setItem('columnsModule', JSON.stringify(mol));
        }
      }
    }
  },
  // 设置 运营端 查询 学校列表
  [types.SET_LEFTSWITCH](state, data) {
    state.leftSwitch = data;
  },

  // 设置 浏览记录
  [types.SET_BROWSINGHISTORYLIST](state, data) {
    if (!data.meta || !data.meta.breadcrumb) {
      return null;
    }
    const key = data.name;
    const breadcrumb = data.meta.breadcrumb.split('-');
    const title = breadcrumb[breadcrumb.length - 1];
    state.browsingHistoryList[key] = {
      routerName: key,
      title,
      query: data.query,
      params: data.params
    };
    localStorage.setItem(
      'browsingHistoryList',
      JSON.stringify(state.browsingHistoryList)
    );

    //  state.browsingHistoryList = data
  },
  // 删除 浏览记录
  [types.CLOSE_BROWSINGHISTORYLIST](state, key) {
    if (key != '') {
      delete state.browsingHistoryList[key];
      state.browsingHistoryList = Object.assign({}, state.browsingHistoryList);
    } else {
      state.browsingHistoryList = {};
    }

    localStorage.setItem(
      'browsingHistoryList',
      JSON.stringify(state.browsingHistoryList)
    );
    console.log('state', state.browsingHistoryList);
  },
  //  state.browsingHistoryList = data
  // 设置 权限集合
  [types.SET_AUTH_MAP](state, data) {
    state.authMap = data;
    localStorage.setItem('430AuthMap', JSON.stringify(data));
  },
  // 设置内容区域缓存实例
  [types.SET_KACI](state, info) {
    state.keepAliveComponentInstance = info;
  },
  // 设置内容区域刷新
  [types.SET_IFROUTERALIVE](state, info) {
    state.ifRouterAlive = info;
  },

  // 设置选择的学校
  [types.SET_SELECTSCHOOL](state, { schoolId, schoolName }) {
    state.schoolIdForState = schoolId;
    state.schoolNameForState = schoolName;
    localStorage.setItem('schoolId', schoolId);
    localStorage.setItem('schoolName', schoolName);
  }
};
